import React from "react";
import styles from "./MTabs.module.css";

interface TabOption {
  value: string;
  label: string;
}

interface MTabsProps<T extends string> {
  activeTab: T;
  tabs: TabOption[];
  onTabChange: (tab: T) => void;
  disabled?: boolean;
}

export const MTabs = <T extends string>({
  activeTab,
  tabs,
  onTabChange,
  disabled = false,
}: MTabsProps<T>) => {
  return (
    <div className={styles.tabsContainer}>
      {tabs.map((tab, index) => (
        <button
          key={tab.value}
          type="button"
          disabled={disabled}
          onClick={() => onTabChange(tab.value as T)}
          className={`${styles.tab} ${
            activeTab === tab.value ? styles.active : ""
          } ${index === 0 ? styles.firstTab : ""} ${
            index === tabs.length - 1 ? styles.lastTab : ""
          } ${disabled ? styles.disabled : ""}`}
        >
          <span className={styles.tabText}>{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MTabs;
